import React, { useState } from 'react';
import { css, cx } from '@emotion/css';
import { Button, colors, TextField } from '@cimpress/react-components';
import IconSearch from '@cimpress-technology/react-streamline-icons/lib/IconSearch';

const searchButtonStyle = css({
  height: '48px',
});

const searchStyle = cx('btn btn-default', searchButtonStyle);

const SearchField = () => {
  const [search, setSearch] = useState('');

  const onClick = () => {
    console.log(`Searching for ${search}`);
  };

  const onChange = e => setSearch(e.target.value);

  return (
    <TextField
      label="Search"
      value={search}
      onChange={onChange}
      rightAddon={
        <Button className={searchStyle} onClick={onClick}>
          <IconSearch color={colors.ocean.base} size="lg" />
        </Button>
      }
    />
  );
};

export default SearchField;
